import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * A dark semitransparent container that can be clicked.
 * Normally used as a control to close a `DrawerPanel` by clicking outside the `DrawerPanelPanel`
 */
const Backdrop = (props) => {
    const classNames = classnames('backdrop', props.className);
    return <div className={classNames} onClick={props.onClick}></div>
};

Backdrop.propTypes = {
    onClick: PropTypes.func
};

export default Backdrop;